import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MenuTopComponent} from './menu-top/menu-top.component';
import {MenuLeftComponent} from './menu-left/menu-left.component';
import {EntitesDropdownlistComponent} from './entites-dropdownlist/entites-dropdownlist.component';
import {MenuItemLeftComponent} from './menu-left/menu-item-left/menu-item-left.component';
import {MenuItemTopComponent} from './menu-top/menu-item-top/menu-item-top.component';
import {MenuItemTopNotificationsComponent} from './menu-top/menu-item-top-notifications/menu-item-top-notifications.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import { EparcoursComponentsModule } from "../eparcours-components/eparcours-components.module";

@NgModule({
  declarations: [
    MenuTopComponent,
    MenuLeftComponent,
    EntitesDropdownlistComponent,
    MenuItemLeftComponent,
    MenuItemTopComponent,
    MenuItemTopNotificationsComponent,
  ],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, RouterModule, EparcoursComponentsModule],
  exports: [MenuLeftComponent, MenuTopComponent],
})
export class MenuModule {}
